import store from "@/redux/store";

import React, { useState } from "react";
import { useParams } from "react-router-dom";

//import {showLoader,hideLoader} from "actions/types";
import { connect } from "react-redux";
import { Gallery } from "@/views/Gallery";

class FileUploadController extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, secret: null };
  }

  render() {
    const { selectedFiles, companystructure } = this.props;
    
    return (
      <Gallery selectedFiles={selectedFiles} companystructure={companystructure}/>
    );
  }
}

const FileUploadControllerInit = (props) => {
  let { selectedFiles, selectedMap } = useParams();
  return (
    <FileUploadController
      {...props}
    />
  );
};

function mapStateToProps(state) {
  const { selectedFiles, companystructure, selectedMap } = state.FileUpload;
  const { data } = state.tree;
  return {
    selectedFiles: selectedFiles,
    companystructure: data,
    selectedMap: selectedMap
  };
}

export default connect(mapStateToProps)(FileUploadControllerInit);
